import { sha256 } from 'crypto-hash';
import { debug } from './debug';

/**
 * Normalizes an email address by trimming and converting to lowercase
 * @param email The email address to normalize
 * @returns The normalized email address
 */
export const normalizeEmail = (email: string): string => {
  return email.trim().toLowerCase();
};

/**
 * Creates a secure hash of an email address for duplicate checking
 * @param email The email address to hash
 * @returns A promise that resolves to the SHA-256 hash of the normalized email
 */
export const hashEmail = async (email: string): Promise<string> => {
  try {
    const normalized = normalizeEmail(email);
    debug.log('Hashing normalized email:', normalized);
    const hash = await sha256(normalized);
    debug.log('Email hash generated successfully');
    return hash;
  } catch (error) {
    debug.error('Error hashing email:', error);
    throw error;
  }
};